import { stringify } from 'query-string';
import { apiCreate, apiGetOne, apiUpdate } from './ApiBaseActions';
// WARNING: Reducer のTS化移行終わるまで変更しない
export const API_GET_ONE_CLIENT_RFP = 'API_GET_ONE_CLIENT_RFP';
export const API_GET_ONE_CLIENT_RFP_SUCCESS = 'API_GET_ONE_CLIENT_RFP_SUCCESS';
export const API_UPDATE_CLIENT_VIEW_REQUEST = 'API_UPDATE_CLIENT_VIEW_REQUEST';
export const API_CREATE_CLIENT_RFP_ADVISER = 'API_CREATE_CLIENT_RFP_ADVISER';
export const API_UPDATE_CLIENT_RFP_QUESTION = 'API_UPDATE_CLIENT_RFP_QUESTION';
export const API_UPDATE_CLIENT_OFFER_APPROACH = 'API_UPDATE_CLIENT_OFFER_APPROACH';
export const API_GET_ONE_CLIENT_OFFER_DOWNLOAD = 'API_GET_ONE_CLIENT_OFFER_DOWNLOAD';
export const API_GET_ONE_CLIENT_OFFER_DOWNLOAD_ONE = 'API_GET_ONE_CLIENT_OFFER_DOWNLOAD_ONE';
export const API_UPDATE_CLIENT_OFFER_SEND_OFF = 'API_UPDATE_CLIENT_OFFER_SEND_OFF';
export const API_CREATE_CLIENT_INTERVIEW = 'API_CREATE_CLIENT_INTERVIEW';
export const API_CREATE_CLIENT_ORDER = 'API_CREATE_CLIENT_ORDER';
export const API_CREATE_CLIENT_OFFER_VIEW_EVENT = 'API_CREATE_CLIENT_OFFER_VIEW_EVENT';
export const API_CREATE_CLIENT_OFFER_DETAIL_VIEW_EVENT = 'API_CREATE_CLIENT_OFFER_DETAIL_VIEW_EVENT';
/**
 * rfpの取得
 * @param id
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneClientRfp = (id, meta = {}) => apiGetOne(API_GET_ONE_CLIENT_RFP, `/client/rfp/${id}`, Object.assign(Object.assign({}, meta), { id, isSnakeCase: true }));
/**
 * view_requestの更新
 * @param id
 * @param viewRequestId
 * @param status
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateClientViewRequest = (id, viewRequestId, status, meta) => apiUpdate(API_UPDATE_CLIENT_VIEW_REQUEST, `/client/rfp/${id}/view_request/${viewRequestId}`, { status }, Object.assign({ id: viewRequestId }, (meta || {})));
/**
 * アドバイザーへの相談
 * @param id
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateClientRfpAdviser = (id, values, meta) => apiCreate(API_CREATE_CLIENT_RFP_ADVISER, `/client/rfp/${id}/contact`, values, Object.assign({ id }, (meta || {})));
/**
 * 質問の回答
 * @param id
 * @param questionId
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateClientRfpQuestion = (id, questionId, values, meta) => apiUpdate(API_UPDATE_CLIENT_RFP_QUESTION, `/client/rfp/${id}/question/${questionId}`, values, Object.assign({ id }, (meta || {})));
/**
 * 提案魅力度の更新
 * @param rfpId
 * @param viewRequestId
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateClientOfferApproach = (rfpId, viewRequestId, values, meta) => apiUpdate(API_UPDATE_CLIENT_OFFER_APPROACH, `/client/rfp/${rfpId}/offer/${viewRequestId}/charm_point`, values, Object.assign({ id: viewRequestId, rfpId,
    viewRequestId }, (meta || {})));
/**
 * 提案内容の一括ダウンロード
 * @param id
 * @param idList
 * @param fileName
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneClientOfferDownload = (id, idList, fileName, meta) => apiGetOne(API_GET_ONE_CLIENT_OFFER_DOWNLOAD, `/client/rfp/${id}/download_offer?${stringify({
    view_request: idList.join(','),
})}`, Object.assign({ fileName,
    id, isBlob: true }, (meta || {})));
/**
 * 提案書・添付資料のダウンロード
 * @param id
 * @param viewRequestId
 * @param fileName
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetOneClientOfferDownloadOne = (id, viewRequestId, fileName, meta) => apiGetOne(API_GET_ONE_CLIENT_OFFER_DOWNLOAD_ONE, `/client/rfp/${id}/download_offer/${viewRequestId}`, Object.assign({ fileName,
    id, isBlob: true }, (meta || {})));
/**
 * 提案の面談辞退の実行
 * @param id
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateClientOfferSendOff = (id, values, meta) => apiUpdate(API_UPDATE_CLIENT_OFFER_SEND_OFF, `/client/rfp/${id}/send_off_offer`, values, Object.assign({ id }, (meta || {})));
/**
 * 面談の申し込み
 * @param rfpId
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateClientInterview = (rfpId, values, meta) => apiCreate(API_CREATE_CLIENT_INTERVIEW, `/client/rfp/${rfpId}/interview`, values, Object.assign({ id: rfpId }, (meta || {})));
/**
 * 発注先の確定
 * @param rfpId
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateClientOrder = (rfpId, values, meta) => apiCreate(API_CREATE_CLIENT_ORDER, `/client/rfp/${rfpId}/order`, values, Object.assign({ id: rfpId }, (meta || {})));
/**
 * 提案のイベントの記録の実行
 * @param id
 * @param event
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateClientOfferViewEvent = (id, event, meta) => apiCreate(API_CREATE_CLIENT_OFFER_VIEW_EVENT, `/client/rfp/${id}/event`, { event }, Object.assign({ id }, (meta || {})));
/**
 * 提案詳細のイベントの記録の実行
 * @param rfpId
 * @param viewRequestId
 * @param event
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateClientOfferDetailViewEvent = (rfpId, viewRequestId, event, meta) => apiCreate(API_CREATE_CLIENT_OFFER_DETAIL_VIEW_EVENT, `/client/rfp/${rfpId}/offer/${viewRequestId}/event`, { event }, Object.assign({ id: viewRequestId, rfpId,
    viewRequestId }, (meta || {})));
